import { CHIP_CONSTANTS } from '../chip/chip-constants';
import { CHIP_SET_CONSTANTS } from './chip-set-constants';
var ChipSetFoundation = /** @class */ (function () {
    function ChipSetFoundation(_adapter) {
        this._adapter = _adapter;
        this._vertical = false;
        this._type = CHIP_CONSTANTS.defaults.TYPE;
        this._dense = false;
        this._disabled = false;
    }
    ChipSetFoundation.prototype.initialize = function () {
        this._applyVertical();
        this._applyType();
        this._applyDense();
        this._applyDisabled();
    };
    ChipSetFoundation.prototype._applyVertical = function () {
        this._adapter.setVertical(this._vertical);
        this._adapter.toggleHostAttribute(CHIP_SET_CONSTANTS.attributes.VERTICAL, this._vertical);
    };
    ChipSetFoundation.prototype._applyType = function () {
        this._adapter.setType(this._type);
        this._adapter.setHostAttribute(CHIP_SET_CONSTANTS.attributes.TYPE, this._type);
    };
    ChipSetFoundation.prototype._applyDense = function () {
        this._adapter.setDense(this._dense);
        this._adapter.toggleHostAttribute(CHIP_SET_CONSTANTS.attributes.DENSE, this._dense);
    };
    ChipSetFoundation.prototype._applyDisabled = function () {
        this._adapter.setDisabled(this._disabled);
        this._adapter.toggleHostAttribute(CHIP_SET_CONSTANTS.attributes.DISABLED, this._disabled);
    };
    Object.defineProperty(ChipSetFoundation.prototype, "vertical", {
        get: function () {
            return this._vertical;
        },
        set: function (value) {
            if (this._vertical !== value) {
                this._vertical = value;
                this._applyVertical();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetFoundation.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            if (this._type !== value) {
                this._type = value;
                this._applyType();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetFoundation.prototype, "dense", {
        get: function () {
            return this._dense;
        },
        set: function (value) {
            if (this._dense !== value) {
                this._dense = value;
                this._applyDense();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetFoundation.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            if (this._disabled !== value) {
                this._disabled = value;
                this._applyDisabled();
            }
        },
        enumerable: true,
        configurable: true
    });
    return ChipSetFoundation;
}());
export { ChipSetFoundation };
